import * as React from 'react'
import { Credenza, CredenzaBody, CredenzaContent, CredenzaDescription, CredenzaHeader, CredenzaTitle } from '~/client/components/ui/credenza'
import { cn } from '~/shared/common/utils'

export type EventCredenzaStep =
  | 'create-event-form'
  | 'add-to-event'
  | 'create-event'
  | 'added-to-event'
  | 'create-shareable-list'
  // edit modes
  | 'edit-event'
  | 'concierge-edit-step1'
  | 'concierge-edit-step2'

type BaseProps = {
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

type EventCredenzaProps = BaseProps & {
  step: EventCredenzaStep
  title?: string
  subtitle?: string
  headerRight?: React.ReactNode
  onStepChange?: (step: EventCredenzaStep) => void
  children?: React.ReactNode
  className?: string
}

export function EventCredenza({ open = false, onOpenChange, step, title, subtitle, headerRight, children, className }: EventCredenzaProps) {
  return (
    <Credenza open={open} onOpenChange={onOpenChange}>
      <CredenzaContent className={cn('sm:rounded-[8px] max-w-full md:max-w-[580px] max-h-[90dvh] min-h-0 flex flex-col', className)}>
        <CredenzaHeader>
          {title ? (
            <div>
              <CredenzaTitle className="text-[20px] font-semibold text-[#18003d]">{title}</CredenzaTitle>
              {subtitle ? <CredenzaDescription className="text-[14px] text-[#6a6262] mt-1">{subtitle}</CredenzaDescription> : null}
            </div>
          ) : null}
          {headerRight}
        </CredenzaHeader>
        <CredenzaBody className="px-[20px] flex-1 min-h-0 overflow-y-auto">
          <AnimatedStep key={step}>{children}</AnimatedStep>
        </CredenzaBody>
      </CredenzaContent>
    </Credenza>
  )
}

function AnimatedStep({ children }: { children?: React.ReactNode }) {
  return (
    <div
      className={
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 data-[state=open]:slide-in-from-bottom-2 data-[state=closed]:slide-out-to-bottom-2'
      }
      data-state="open"
    >
      {children}
    </div>
  )
}
